module.exports = __webpack_public_path__ + "static/media/logo_group _blanco_01.b53ea4f8.png";